import React from 'react';

import CloseIcon from '../../assets/close-icon';
import ArrowRightIcon from '../../assets/arrow-right-icon';
import Modal from '../../components/modal';
import { API } from '../../helpers/constants';
import useGet from '../../hook/use-get';
import LoadingDetails from './components/loading-details';
import Error from '../../components/error';

const RouteInfo = ({ route, isFirstIndex }) => {
  return (
    <div className="inline-flex mx-2 justify-center items-center">
      <ArrowRightIcon variant={isFirstIndex ? 'active' : 'inactive'} />
      <p className="ml-4">{route}</p>
    </div>
  );
};

const TrafficDetails = ({ id, onHide }) => {
  const { data, isError, isFetching, refetch } = useGet({
    queryKey: 'trafficDetails',
    api: `${API.trafficDetails}?id=${id}`,
    options: {
      enabled: !!id
    }
  });

  const RenderContent = () => {
    if (isFetching) {
      return <LoadingDetails />;
    }

    if (isError) {
      return (
        <div className="p-5">
          <Error onBack={onHide} refetch={refetch} />
        </div>
      );
    }

    return (
      <>
        <div className="flex-col p-5 border-b border-solid border-blueGray-200 rounded-t">
          <div className="flex flex-col-reverse md:flex-row items-start justify-between">
            <h3 className="text-2xl font-bold text-left">{data?.name}</h3>
            <button className="mb-2 md:mb-0" onClick={onHide}>
              <CloseIcon />
            </button>
          </div>
          <h4 className="flex self-start text-base text-gray-500">{data?.['city_name']}</h4>
        </div>
        <div className="relative px-6 flex-auto">
          <h3 className="text-xl font-semibold text-left">Jalur Utama</h3>
          <p className="my-4 text-left text-blueGray-500 text-lg leading-relaxed">
            {data?.['jalur_utama']?.map((route, index) => (
              <RouteInfo isFirstIndex={index === 0} route={route} />
            ))}
          </p>
          <hr className="my-4" />
          <h3 className="text-xl font-semibold text-left">Jalur Alternatif</h3>
          <p className="my-4 text-left text-blueGray-500 text-lg leading-relaxed">
            {data?.['jalur_alternatif']?.map((route) => {
              return (
                <div>
                  {route?.name?.map((route, index) => (
                    <RouteInfo isFirstIndex={index === 0} route={route} />
                  ))}
                </div>
              );
            })}
          </p>
        </div>
      </>
    );
  };

  return (
    <Modal>
      <div className="md:mx-0 w-[90%] my-6 mx-auto lg:max-w-3xl rounded-lg bg-white space-y-3 max-h-[90%] md:h-auto overflow-scroll">
        <RenderContent />
      </div>
    </Modal>
  );
};

export default TrafficDetails;
